import LazyContent from './LazyContent'

export default LazyContent
